export default {
  // 画土拍
  drawLandDeal(currentMap, needDot) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getLandDeal", {
        params: {
          default_batch: 1
        },
      })
      .then((res) => {
        let list = res.data.data.list;
        console.log("drawLandDeal", list);
        let mapData = {};
        for (let i = 0; i < list.length; i++) {
          let loc = list[i];
          let mclass = "landDeal1";
          let other = "";
          if (!list[i].wait) {
            mclass = "landDeal";
            other = `<div class="realPrice-c">${
              (loc.develop && loc.develop + " ") || ""
            }自持${loc.hold || "无"}</div>`;
          }
          let limitStr = "";
          if (loc.limitj) {
            limitStr = `<div class="realPrice-c">精装限价${loc.limitj}</div>`;
          } else if (loc.limitm) {
            limitStr = `<div class="realPrice-c">毛坯限价${loc.limitm}</div>`;
          }
          let markerContent = `
            <div class="${mclass}">
              <div>${loc.name}</div>
              <div>${loc.number}</div>
              ${limitStr}
              ${other}
            </div>
            `;

          let showList = [];
          if (loc.limitj) {
            showList.push(`<div>精装限价：${loc.limitj}</div>`);
          }
          if (loc.limitm) {
            showList.push(`<div>毛坯限价：${loc.limitm}</div>`);
          }
          if (loc.capacity) {
            showList.push(`<div>容积率：${loc.capacity}</div>`);
          }
          // if (loc.purpose) {
          //   showList.push(`<div>土地用途：${loc.purpose}</div>`)
          // }
          if (loc.floor_price) {
            showList.push(`<div>楼面价：${loc.floor_price}</div>`);
          }
          if (loc.develop) {
            showList.push(`<div>竞得方：${loc.develop}</div>`);
          } else if (loc.owner) {
            showList.push(`<div>竞得方：${loc.owner}</div>`);
          }
          if (loc.premium) {
            showList.push(`<div>溢价率：${loc.premium}</div>`);
          }
          markerContent = `
            <div class="land-wait">
              <div class="land-wait-head">${loc.number || loc.name}</div>
              <div class="land-wait-box">
                ${showList.join("")}
              </div>
            </div>
          `;

          let realPos = loc.lnglat.split("|");
          let position = realPos;
          if (loc.move && !needDot) {
            position = loc.move.split("|");
            mapData[loc.id] = {
              marker: realPos,
              line: [realPos, position],
            };
          }

          let nameLen = loc.number.length;
          if (nameLen <= 6) {
            nameLen = 6.5;
          }
          let offsetX = -95;
          let offsetY = -30;

          let marker = new AMap.Marker({
            land_id: loc.id,
            position: position,
            content: markerContent,
            offset: new AMap.Pixel(offsetX, offsetY),
            draggable: true,
          });
          if (needDot) {
            marker = new AMap.Marker({
              land_id: loc.id,
              position: realPos,
              content: '<div class="circle"></div>',
              offset: new AMap.Pixel(-5, -5),
            });
          }
          marker.on("dragstart", (e) => {
            console.log("开始移动", e.target.w.land_id);
            let land_id = e.target.w.land_id;
            if (!that.landMarkers[land_id]) {
              let dot = loc.lnglat.split("|");
              let temp = JSON.parse(JSON.stringify(that.landMarkers));
              temp[land_id] = {
                marker: dot,
                line: [dot, dot],
              };
              that.landMarkers = temp;
            }
          });
          marker.on("dragging", (e) => {
            let land_id = e.target.w.land_id;
            let temp = JSON.parse(JSON.stringify(that.landMarkers));
            temp[land_id].line[1] = [e.lnglat.lng, e.lnglat.lat];
            that.landMarkers = temp;
          });
          marker.on("dragend", (e) => {
            console.log("移动结束", that.landMarkers);
            let land_id = e.target.w.land_id;
            let temp = JSON.parse(JSON.stringify(that.landMarkers));
            let pos = e.target.getPosition();
            temp[land_id].line[1] = [pos.lng, pos.lat];
            that.landMarkers = temp;
            that.saveLandMarkers(land_id);
          });
          marker.on("rightclick", (e) => {
            console.log("右击", e);
            let land_id = e.target.w.land_id;
            if (that.landMarkers[land_id]) {
              let temp = JSON.parse(JSON.stringify(that.landMarkers));
              e.target.setPosition(temp[land_id].marker);
              delete temp[land_id];
              that.landMarkers = temp;
              that.saveLandMarkers(land_id);
            }
          });

          marker.setMap(currentMap);
        }
        that.landMarkers = mapData;
      });
  },

  // 画土拍（同时显示圆点和信息卡片）
  drawLandDealWithCard(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getLandDeal", {
        params: {
          default_batch: 1
        },
      })
      .then((res) => {
        let list = res.data.data.list;
        console.log("drawLandDealWithCard", list);
        let mapData = {};

        // 重置边界计数器
         this.borderCardCounts = { right: 0, bottom: 0, left: 0, top: 0 };

        // 存储已放置的卡片位置，用于碰撞检测
        let placedCards = [];
        // 存储所有圆点位置，用于避免卡片遮挡圆点
        let allDotPositions = [];

        // 首先收集所有圆点位置
        for (let i = 0; i < list.length; i++) {
          let loc = list[i];
          let realPos = loc.lnglat.split("|");
          allDotPositions.push({
            lng: parseFloat(realPos[0]),
            lat: parseFloat(realPos[1]),
            id: loc.id
          });
        }

        // 调试：显示圆点保护区域
        that.showDotProtectionZones(currentMap, allDotPositions);

        // 调试：显示地图中心点和方向线
        that.showMapCenterAndDirections(currentMap, allDotPositions);

        for (let i = 0; i < list.length; i++) {
          let loc = list[i];

          // 构建信息卡片内容
          let showList = [];
          if (loc.wait) {
            showList.push(`<div>竞得方：待出让</div>`);
            showList.push(`<div>起拍价：${loc.base_price || '-'} 万元</div>`);
            showList.push(`<div>占地面积：${loc.square || '-'}㎡</div>`);
            showList.push(`<div>容积率：${loc.capacity || '-'}</div>`);
            showList.push(`<div>土地编号：${loc.number || '-'}</div>`);
            showList.push(`<div>土地用途：${loc.purpose || '-'}</div>`);
          } else {
            showList.push(`<div>竞得方：${loc.develop || '-'}</div>`);
            showList.push(`<div>成交价：${loc.deal_price || '-'} 万元</div>`);
            showList.push(`<div>占地面积：${loc.square || '-'}㎡</div>`);
            showList.push(`<div>容积率：${loc.capacity || '-'}</div>`);
            showList.push(`<div>楼面价：${loc.floor_price || '-'} 元/㎡</div>`);
            showList.push(`<div>溢价率：${loc.premium || '-'}%</div>`);
            showList.push(`<div>土地编号：${loc.number || '-'}</div>`);
          }
          let cardContent = `
            <div class="land-wait1">
              <div class="land-wait1-head">${loc.name}</div>
              <div class="land-wait1-box">
                ${showList.join("")}
              </div>
            </div>
          `;

          let realPos = loc.lnglat.split("|");

          // 获取卡片实际尺寸
          let cardDimensions = that.getCardDimensions(cardContent);

          // 计算卡片位置（边界贴靠策略）
          let cardOffset = that.calculateCardPosition(
            realPos,
            i,
            list.length,
            placedCards,
            cardDimensions,
            allDotPositions
          );
          // 边界贴靠策略返回的是绝对偏移量，不需要乘以距离系数
          let cardPosition = [
            parseFloat(realPos[0]) + cardOffset.x,
            parseFloat(realPos[1]) + cardOffset.y,
          ];

          console.log(`卡片 ${i} 最终位置: lng=${cardPosition[0].toFixed(6)}, lat=${cardPosition[1].toFixed(6)}`);

          // 记录已放置的卡片位置
          placedCards.push({
            position: cardPosition,
            dotPosition: realPos.map(coord => parseFloat(coord)), // 添加圆点位置信息
            width: cardDimensions.width,
            height: cardDimensions.height
          });

          // 创建圆点标记
          let dotMarker = new AMap.Marker({
            land_id: loc.id,
            position: realPos,
            content: '<div class="circle1"></div>',
            offset: new AMap.Pixel(-20, -20),
            draggable: true,
          });

          // 创建信息卡片标记
          let cardMarker = new AMap.Marker({
            land_id: loc.id + "_card",
            position: cardPosition,
            content: cardContent,
            offset: new AMap.Pixel(-200, -300), // 卡片中心偏移，确保连线指向卡片中间
            draggable: true,
            zIndex: 999,
          });
          // 创建连接线
          let polyline = new AMap.Polyline({
            path: [realPos, cardPosition],
            strokeColor: "#333333",
            strokeWeight: 8,
            strokeStyle: "solid",
            strokeOpacity: 1,
          });

          // 将标记和线条添加到地图
          dotMarker.setMap(currentMap);
          cardMarker.setMap(currentMap);
          polyline.setMap(currentMap);

          // 调试：显示卡片边界框
          that.showCardBounds(currentMap, cardPosition, cardDimensions);
        }
        that.landMarkers = mapData;
      });
  },

  // 计算卡片合适位置，使用边界贴靠策略
  calculateCardPosition(realPos, index, total, placedCards = [], cardDimensions = null, allDotPositions = []) {
    // 使用智能边界贴靠位置分配
    let smartPosition = this.calculateSmartPosition(realPos, index, total, allDotPositions, cardDimensions);

    console.log(`卡片 ${index} 边界贴靠策略，放置在 ${smartPosition.boundary} 边界，偏移量: (${smartPosition.x.toFixed(4)}, ${smartPosition.y.toFixed(4)})`);

    // 直接返回边界贴靠的结果，不进行任何调整
    return { x: smartPosition.x, y: smartPosition.y };
  },

  // 获取卡片实际尺寸（通过DOM渲染获取真实尺寸）
  getCardDimensions(cardContent) {
    try {
      // 创建临时容器来测量实际尺寸
      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'absolute';
      tempContainer.style.visibility = 'hidden';
      tempContainer.style.top = '-9999px';
      tempContainer.style.left = '-9999px';
      tempContainer.style.pointerEvents = 'none';

      // 设置卡片内容
      tempContainer.innerHTML = cardContent;

      // 添加到页面中进行渲染
      document.body.appendChild(tempContainer);

      // 获取实际渲染尺寸
      const rect = tempContainer.getBoundingClientRect();
      const actualWidth = Math.ceil(rect.width) || 348; // 如果获取失败使用默认值
      const actualHeight = Math.ceil(rect.height) || 200;

      // 清理临时元素
      document.body.removeChild(tempContainer);

      // 判断是否为待出让土地（包含"待出让"字样）
      const isWaitingLand = cardContent.includes('待出让');

      console.log(`卡片真实尺寸: 类型=${isWaitingLand ? '待出让' : '已成交'}, 实际宽度=${actualWidth}px, 实际高度=${actualHeight}px`);

      return {
        width: actualWidth,
        height: actualHeight
      };
    } catch (error) {
      console.error('获取卡片真实尺寸失败，使用默认尺寸:', error);
      // 如果DOM操作失败，回退到基础尺寸
      return {
        width: 348,
        height: 200
      };
    }
  },

  // 调试：显示卡片边界框（可选）
  showCardBounds(currentMap, cardPosition, cardDimensions) {
    if (!this.debugMode) return;

    const pixelToLngLat = 0.0001;
    const widthOffset = (cardDimensions.width / 2) * pixelToLngLat;
    const heightOffset = (cardDimensions.height / 2) * pixelToLngLat;

    const bounds = [
      [cardPosition[0] - widthOffset, cardPosition[1] - heightOffset],
      [cardPosition[0] + widthOffset, cardPosition[1] + heightOffset]
    ];

    const rectangle = new AMap.Rectangle({
      bounds: bounds,
      strokeColor: "#FF0000",
      strokeWeight: 1,
      strokeStyle: "dashed",
      fillColor: "#FF0000",
      fillOpacity: 0.1
    });

    rectangle.setMap(currentMap);
  },

  // 调试：显示圆点保护区域（可选）
  showDotProtectionZones(currentMap, allDotPositions) {
    if (!this.debugMode) return;

    for (let dotPos of allDotPositions) {
      const circle = new AMap.Circle({
        center: [dotPos.lng, dotPos.lat],
        radius: 0.02, // 保护半径
        strokeColor: "#00FF00",
        strokeWeight: 1,
        strokeStyle: "dashed",
        fillColor: "#00FF00",
        fillOpacity: 0.1
      });

      circle.setMap(currentMap);
    }
  },

  // 调试：显示地图中心点和方向线（可选）
  showMapCenterAndDirections(currentMap, allDotPositions) {
    if (!this.debugMode) return;

    const mapCenter = { lng: 120.128847, lat: 30.223938 };

    // 显示地图中心点
    const centerMarker = new AMap.Marker({
      position: [mapCenter.lng, mapCenter.lat],
      content: '<div style="width:20px;height:20px;background:blue;border-radius:50%;border:2px solid white;"></div>',
      offset: new AMap.Pixel(-10, -10)
    });
    centerMarker.setMap(currentMap);

    // 显示从中心到每个圆点的方向线
    for (let dotPos of allDotPositions) {
      const polyline = new AMap.Polyline({
        path: [[mapCenter.lng, mapCenter.lat], [dotPos.lng, dotPos.lat]],
        strokeColor: "#0000FF",
        strokeWeight: 1,
        strokeStyle: "dashed",
        strokeOpacity: 0.5
      });
      polyline.setMap(currentMap);
    }
  },

  // 智能位置分配：真正的边界贴靠策略
  calculateSmartPosition(realPos, index, total, allDotPositions, cardDimensions) {
    const lng = parseFloat(realPos[0]);
    const lat = parseFloat(realPos[1]);

    // 初始化边界计数器（如果不存在）
    if (!this.borderCardCounts) {
      this.borderCardCounts = { right: 0, bottom: 0, left: 0, top: 0 };
    }

    // 使用高德地图API获取当前地图视窗的真实边界
    let mapBounds;
    try {
      const currentMap = this.$refs.make_map.$$getInstance();
      const bounds = currentMap.getBounds();
      mapBounds = {
        minLng: bounds.southwest.lng,
        maxLng: bounds.northeast.lng,
        minLat: bounds.southwest.lat,
        maxLat: bounds.northeast.lat
      };
      console.log('使用高德地图API获取的边界:', mapBounds);
    } catch (error) {
      console.warn('无法获取地图边界，使用备用计算方式:', error);
      // 备用方案：基于所有圆点计算边界
      let minLng = lng, maxLng = lng, minLat = lat, maxLat = lat;
      if (allDotPositions && allDotPositions.length > 0) {
        allDotPositions.forEach(pos => {
          const posLng = parseFloat(pos.lng || pos[0]);
          const posLat = parseFloat(pos.lat || pos[1]);
          if (posLng < minLng) minLng = posLng;
          if (posLng > maxLng) maxLng = posLng;
          if (posLat < minLat) minLat = posLat;
          if (posLat > maxLat) maxLat = posLat;
        });
      }

      const padding = 0.02;
      mapBounds = {
        minLng: minLng - padding,
        maxLng: maxLng + padding,
        minLat: minLat - padding,
        maxLat: maxLat + padding
      };
    }

    // 卡片尺寸和边界设置
    const pixelToLngLat = 0.0001; // 像素到经纬度转换系数（减小以让卡片更贴近边界）
    let cardWidthOffset, cardHeightOffset;

    if (cardDimensions) {
      // 基于实际卡片尺寸计算偏移量
      cardWidthOffset = (cardDimensions.width / 2) * pixelToLngLat;
      cardHeightOffset = (cardDimensions.height / 2) * pixelToLngLat;
      console.log(`卡片 ${index} 实际尺寸: ${cardDimensions.width}x${cardDimensions.height}px, 偏移量: ${cardWidthOffset.toFixed(6)}, ${cardHeightOffset.toFixed(6)}`);
    } else {
      // 使用默认值作为后备
      cardWidthOffset = 0.035;
      cardHeightOffset = 0.030;
      console.log(`卡片 ${index} 使用默认偏移量: ${cardWidthOffset}, ${cardHeightOffset}`);
    }

    const borderMargin = 0.0;     // 边界间距（减小以让卡片更贴近边界）
    // 优化边界容量分配：优先考虑距离，而不是严格平均分配
    // 对于少量卡片，允许更灵活的分配
    let maxCardsPerBorder;
    if (total <= 4) {
      maxCardsPerBorder = total; // 少量卡片时，每个边界都可以容纳所有卡片
    } else {
      maxCardsPerBorder = Math.ceil(total / 3); // 使用3个边界分配，留一个边界作为备用
    }

    console.log(`总卡片数: ${total}, 每边界最大容量: ${maxCardsPerBorder}`);

    // 1. 计算圆点到四条边界的距离
    const distances = {
      right: mapBounds.maxLng - lng,
      bottom: lat - mapBounds.minLat,
      left: lng - mapBounds.minLng,
      top: mapBounds.maxLat - lat
    };

    // 2. 按距离排序，得到边界优先级
    const borderPriority = Object.keys(distances)
      .sort((a, b) => distances[a] - distances[b]);

    console.log(`卡片 ${index} 边界距离:`, distances);
    console.log(`边界优先级:`, borderPriority);

    // 3-5. 智能边界选择：综合考虑距离和负载
    let selectedBorder = null;

    // 首先尝试选择距离最近且未满的边界
    for (const border of borderPriority) {
      if (this.borderCardCounts[border] < maxCardsPerBorder) {
        selectedBorder = border;
        break;
      }
    }

    // 如果所有边界都满了，使用加权评分系统
    if (!selectedBorder) {
      let bestScore = Infinity;
      let bestBorder = borderPriority[0];

      for (const border of borderPriority) {
        // 计算综合评分：距离权重70% + 负载权重30%
        const distanceScore = distances[border];
        const loadScore = this.borderCardCounts[border] / maxCardsPerBorder;
        const totalScore = distanceScore * 0.7 + loadScore * 0.3;

        if (totalScore < bestScore) {
          bestScore = totalScore;
          bestBorder = border;
        }
      }

      selectedBorder = bestBorder;
      console.log(`所有边界已满，使用加权评分选择 ${selectedBorder} 边界`);
    }

    // 更新边界计数
    const positionInBorder = this.borderCardCounts[selectedBorder];
    this.borderCardCounts[selectedBorder]++;

    // 6. 在选定边界上按投影位置智能排列
    let finalX, finalY;

    switch(selectedBorder) {
      case 'right': // 右边界 - 放置在地图内部右侧
        finalX = mapBounds.maxLng - borderMargin - cardWidthOffset;
        // 垂直分布，考虑投影位置
        const rightHeight = mapBounds.maxLat - mapBounds.minLat - 2 * borderMargin - 2 * cardHeightOffset;
        const rightSpacing = rightHeight / Math.max(1, maxCardsPerBorder);
        finalY = mapBounds.minLat + borderMargin + cardHeightOffset + positionInBorder * rightSpacing;
        break;

      case 'bottom': // 下边界 - 放置在地图内部下侧
        finalY = mapBounds.minLat + borderMargin + cardHeightOffset;
        // 水平分布，考虑投影位置
        const bottomWidth = mapBounds.maxLng - mapBounds.minLng - 2 * borderMargin - 2 * cardWidthOffset;
        const bottomSpacing = bottomWidth / Math.max(1, maxCardsPerBorder);
        finalX = mapBounds.minLng + borderMargin + cardWidthOffset + positionInBorder * bottomSpacing;
        break;

      case 'left': // 左边界 - 放置在地图内部左侧
        finalX = mapBounds.minLng + borderMargin + cardWidthOffset;
        // 垂直分布，考虑投影位置
        const leftHeight = mapBounds.maxLat - mapBounds.minLat - 2 * borderMargin - 2 * cardHeightOffset;
        const leftSpacing = leftHeight / Math.max(1, maxCardsPerBorder);
        finalY = mapBounds.minLat + borderMargin + cardHeightOffset + positionInBorder * leftSpacing;
        break;

      case 'top': // 上边界 - 放置在地图内部上侧
        finalY = mapBounds.maxLat - borderMargin - cardHeightOffset;
        // 水平分布，考虑投影位置
        const topWidth = mapBounds.maxLng - mapBounds.minLng - 2 * borderMargin - 2 * cardWidthOffset;
        const topSpacing = topWidth / Math.max(1, maxCardsPerBorder);
        finalX = mapBounds.minLng + borderMargin + cardWidthOffset + positionInBorder * topSpacing;
        break;
    }

    // 7. 边界约束检查，确保卡片在地图范围内，增加额外安全边距
    const extraSafetyMargin = 0.0; // 额外安全边距（减小以让卡片更贴近边界）
    finalX = Math.max(mapBounds.minLng + borderMargin + cardWidthOffset + extraSafetyMargin,
                     Math.min(finalX, mapBounds.maxLng - borderMargin - cardWidthOffset - extraSafetyMargin));
    finalY = Math.max(mapBounds.minLat + borderMargin + cardHeightOffset + extraSafetyMargin,
                     Math.min(finalY, mapBounds.maxLat - borderMargin - cardHeightOffset - extraSafetyMargin));

    // 8. 连线交叉检测和微调（简化版）
    // 检查是否与其他卡片位置冲突，如有冲突则微调
    const minDistance = 0.01; // 最小卡片间距
    if (allDotPositions && allDotPositions.length > 0) {
      for (let i = 0; i < index; i++) {
        const otherPos = allDotPositions[i];
        if (otherPos && otherPos.cardPosition) {
          const distance = Math.sqrt(
            Math.pow(finalX - otherPos.cardPosition[0], 2) +
            Math.pow(finalY - otherPos.cardPosition[1], 2)
          );
          if (distance < minDistance) {
            // 微调位置避免重叠
            if (selectedBorder === 'right' || selectedBorder === 'left') {
              finalY = finalY + minDistance; // 垂直微调
            } else {
              finalX = finalX + minDistance; // 水平微调
            }
          }
        }
      }
    }

    // 计算相对于圆点的偏移量
    const offsetX = finalX - lng;
    const offsetY = finalY - lat;

    console.log(`卡片 ${index} 智能分配到 ${selectedBorder} 边界 (位置 ${positionInBorder})`);
    console.log(`  圆点位置: lng=${lng.toFixed(6)}, lat=${lat.toFixed(6)}`);
    console.log(`  最终位置: lng=${finalX.toFixed(6)}, lat=${finalY.toFixed(6)}`);
    console.log(`  偏移量: x=${offsetX.toFixed(6)}, y=${offsetY.toFixed(6)}`);
    console.log(`  边界计数:`, this.borderCardCounts);

    return {
      x: offsetX,
      y: offsetY,
      boundary: selectedBorder
    };
  },
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindLand.js